<h2 mat-dialog-title *ngIf="dialog.title">
  {{ dialog.title }}
</h2>
<div mat-dialog-content *ngIf="dialog.content || dialog.contentHtml">
  <span *ngIf="dialog.content">{{dialog.content}}</span>
  <span *ngIf="dialog.contentHtml" [innerHtml]="dialog.contentHtml"></span>
</div>
<div mat-dialog-actions style="justify-content: flex-end;">
  <button *ngIf="dialog.cancel" color="default" type="button" mat-button (click)="dialogRef.close(false)">
    {{ dialog.cancel }}
  </button>
  <button *ngIf="dialog.close" color="primary" type="button" mat-flat-button (click)="dialogRef.close(false)">
    {{ dialog.close }}
  </button>
  <button *ngIf="dialog.confirm" color="accent" type="button" mat-flat-button (click)="dialogRef.close(true)">
    {{ dialog.confirm }}
  </button>
</div>